import type { JWTContextUser } from '@savvy/deprecated-shared/api/user-api';

export function canViewAdminFeatures(user: JWTContextUser | undefined): boolean {
  return isSavvyAdmin(user) || user?.role === 'CSA' || user?.role === 'READ_ONLY_ADMIN'; // TODO: should CSA be removed?
}

/** CSA review banners are CSA-facing. Most CSAs hold ADMIN_CSA, not CSA. */
export function canSeeCsaReviewBanner(user: JWTContextUser | null | undefined) {
  if (user === null || user === undefined) {
    return false;
  }

  return user.role === 'CSA' || user.role === 'ADMIN_CSA';
}

/**
 * Roles AuthGuard's forAdmin admits — narrower than `admin_or_read_only_admin?`, which also covers
 * `csa_system_admin` (absent from the `UserRole` GraphQL enum). Gate links *into* an admin page
 * here; gate the data itself at the API.
 */
export function canOpenAdminOnlyPage(user: JWTContextUser | null | undefined) {
  if (user === null || user === undefined) {
    return false;
  }

  return user.role === 'ADMIN' || user.role === 'ADMIN_CSA' || user.role === 'READ_ONLY_ADMIN';
}

/** Savvy platform admins only — excludes advisor CSAs and read-only admins. */
export function isSavvyAdmin(user: JWTContextUser | undefined) {
  if (user === null || user === undefined) {
    return false;
  }

  return user.role === 'ADMIN' || user.role === 'ADMIN_CSA';
}
